// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistemaFranquia_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/configuracoes_sistema_franquia/save
 *
 * Creates or updates a franchise-specific system configuration override.
 * The backend auto-detects whether to create or update based on existence.
 */
import { registerContract } from './validate'

export interface ConfiguracoesSistemaFranquia_SaveInput {
nome: string
franquia_id: number
valor: string
}

registerContract('ConfiguracoesSistemaFranquia_SaveInput', {
  nome:        { type: 'string',  required: true },
  franquia_id: { type: 'number',  required: true },
  valor:       { type: 'string',  required: true },
})
